import {EtsyListing, etsySettings} from '@coolcolduk/etsy';
import SaveIcon from '@mui/icons-material/Save';
import {Button, Grid} from '@mui/material';

export interface EtsyUpdateListingSeoItemEditorFooterProps {
  listing: EtsyListing;
  title: string;
  tags: string[];
  onClose: () => void;
  onSave: (title: string, tags: string[]) => void;
}

export default function EtsyUpdateListingSeoItemEditorFooter({
  listing,
  title,
  tags,
  onClose,
  onSave,
}: EtsyUpdateListingSeoItemEditorFooterProps) {
  const hasChanges = title !== listing.title || JSON.stringify(tags) !== JSON.stringify(listing.tags || []);
  const hasError = tags.length > etsySettings.listing.tags.maxCount;

  const handleSave = () => {
    onSave(title, tags);
    onClose();
  };

  return (
    <Grid container direction="row" spacing={1} justifyContent="flex-end">
      <Button variant="outlined" onClick={onClose}>
        Close
      </Button>
      <Button
        variant="contained"
        color="success"
        startIcon={<SaveIcon />}
        onClick={handleSave}
        disabled={!hasChanges || hasError}
      >
        Save Changes
      </Button>
    </Grid>
  );
}
